import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';

import SpecList from '@reverbdotcom/commons/src/components/spec_list';
import { RCToggledContent } from '@reverbdotcom/cadence/components';
import { isCoreBrandNew } from '@reverbdotcom/commons/src/condition_helpers';
import { Item2ProductSpecsData } from '../schemas/rql';
import { TruncationContainer } from '@reverbdotcom/commons/src/components/truncation_container';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

const TRUNCATION_CONTAINER_REM_HEIGHT = 25;

const trackClick = (collapsed, listing) => {
  trackEvent({
    eventName: MParticleEventName.ClickedToggledContent,
    componentName: 'Item2ProductSpecs',
    interactionType: collapsed ? 'collapse' : 'expand',
    listing,
  });
};

export const Item2ProductSpecsFragment = gql`
  fragment Item2ProductSpecsData on Listing {
    _id
    publishedAt {
      seconds
    }
    hasInventory
    condition {
      conditionUuid
    }
    specs {
      productSpecs {
        name
        value
        path
        slug
        type
      }
    }
  }
`;

interface IProps {
  listing: Item2ProductSpecsData.Fragment;
}

export function Item2ProductSpecs({ listing }: IProps) {
  if (!listing.specs?.productSpecs) return null;

  const hideDateListed = isCoreBrandNew(listing.condition.conditionUuid) || listing.hasInventory;

  return (
    <RCToggledContent
      heading={I18n.t('discovery.item2Description.specs')}
      id="product-specs"
      defaultOpen
      onToggle={(collapsed) => trackClick(collapsed, listing)}
    >
      <TruncationContainer
        remMaxHeight={TRUNCATION_CONTAINER_REM_HEIGHT}
        trackingName="Item2ProductSpecs"
      >
        <SpecList
          specs={listing.specs.productSpecs}
          dateListed={!hideDateListed && listing.publishedAt?.seconds}
        />
      </TruncationContainer>
    </RCToggledContent>
  );
}
